import { useState } from "react";
import { Trash2, Plus } from "lucide-react";
import { saveTaskTemplate } from "../../utils/firebasefunctions";
import { cleanTemplate, isSectionItem } from "../../utils/taskSections";

// Editor row for a section header inside a stage. Lets you rename the section,
// delete it (header only — its tasks stay), and add a task into it.
const SectionRow = ({ section, status, tasks, setTasks, setEditingTaskId }) => {
  const [title, setTitle] = useState(section.title);

  const persist = (updated) => {
    setTasks(updated);
    saveTaskTemplate(cleanTemplate(updated));
  };

  const renameSection = () => {
    const updated = {
      ...tasks,
      [status]: (tasks[status] || []).map((it) =>
        isSectionItem(it) && it.id === section.id ? { ...it, title: title.trim() || "Untitled Section" } : it,
      ),
    };
    persist(updated);
  };

  // Delete the header item only; its tasks remain in the array (merge upward).
  const deleteSection = () => {
    const updated = {
      ...tasks,
      [status]: (tasks[status] || []).filter((it) => !(isSectionItem(it) && it.id === section.id)),
    };
    persist(updated);
  };

  // Insert a new empty task immediately after this section header.
  const addTaskInSection = () => {
    const list = tasks[status] || [];
    const idx = list.findIndex((it) => isSectionItem(it) && it.id === section.id);
    const newTask = {
      type: "task",
      id: Date.now(),
      title: "",
      assignee: null,
      deadline: "",
      attachments: [],
      createdAt: new Date(),
    };
    const next = [...list.slice(0, idx + 1), newTask, ...list.slice(idx + 1)];
    const updated = { ...tasks, [status]: next };
    setTasks(updated);
    setEditingTaskId(newTask.id);
    saveTaskTemplate(cleanTemplate(updated));
  };

  return (
    <div className="flex items-center justify-between bg-[#1E293B]/5 border-l-4 border-[#1E293B] rounded px-3 py-2 mt-2">
      <input
        className="bg-transparent font-bold text-sm text-[#1E293B] outline-none w-[60%]"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onBlur={renameSection}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); e.currentTarget.blur(); } }}
      />
      <div className="flex items-center gap-2">
        <button
          className="text-xs font-semibold text-[#1E293B] hover:text-green-600 flex items-center gap-1"
          onClick={addTaskInSection}
        >
          <Plus size={14} /> Add Task
        </button>
        <Trash2
          size={16}
          className="cursor-pointer text-gray-400 hover:text-red-500"
          onClick={deleteSection}
        />
      </div>
    </div>
  );
};

export default SectionRow;
